var React = require('react');
var styles = require('./Page2.scss');
import Divider from './Divider';

var Page2 = React.createClass({
    propTypes: {
        values: React.PropTypes.object,
        processing: React.PropTypes.bool,
    },
    getInitialState: function() {
        return {
            visible: this.props.visible,
            values: this.props.values
        };
    },
    getDefaultProps: function() {
        return {
            values: {
                personData: {
                    firstname: '',
                    surname: '',
                    gender: '',
                    birth: '',
                    email: '',
                    address: '',
                    zipcode: '',
                    city: '',
                    country: '',
                    phone: '',
                    other: ''
                }
            },
            processing: false,
            visible: true
        };
    },
    componentWillReceiveProps: function(nextProps) {
        this.setState({
            visible: nextProps.visible,
            values: nextProps.values,
            processing: nextProps.processing
        });
    },
    render: function() {
        if (!this.state.visible) {
            return null;
        }
        var buttonClass = ['primary-btn'];
        var buttonText = 'Book';
        if (this.state.processing) {
            buttonClass.push('processing');
            buttonText = 'processing...';
        }
        return (
            <div className={[styles.wrapper, 'wrapper-640'].join(' ')}>
                <div className={[styles.form, 'j-forms'].join(' ')}>
                    <div className={styles.content}>

                        <Divider value={0} label="Booking information" />

                        <div className={[styles.unit, styles.package].join(' ')}>
                            <table className={styles.pinfo}>
                                <tbody>
                                <tr>
                                    <td>First name:</td><td>{this.state.values.personData.firstname}</td>
                                </tr>
                                <tr>
                                    <td>Surname:</td><td>{this.state.values.personData.surname}</td>
                                </tr>
                                <tr>
                                    <td>Gender</td><td>{this.state.values.personData.gender}</td>
                                </tr>
                                <tr>
                                    <td>Date of birth</td><td>{this.state.values.personData.birth}</td>
                                </tr>
                                <tr>
                                    <td>E-mail</td><td>{this.state.values.personData.email}</td>
                                </tr>
                                <tr>
                                    <td>Address</td><td>{this.state.values.personData.address}</td>
                                </tr>
                                <tr>
                                    <td>Zip code</td><td>{this.state.values.personData.zipcode}</td>
                                </tr>
                                <tr>
                                    <td>City</td><td>{this.state.values.personData.city}</td>
                                </tr>
                                <tr>
                                    <td>Country</td><td>{this.state.values.personData.country}</td>
                                </tr>
                                <tr>
                                    <td>Phone</td><td>{this.state.values.personData.phone}</td>
                                </tr>
                                <tr>
                                    <td>Other</td><td>{this.state.values.personData.other}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="footer">
                        <button type="button" id="book" onClick={this.handleSubmitClick} className={buttonClass.join(' ')}>{buttonText}</button>
                        <button type="button" id="back-button" onClick={this.handleBackClick} className="primary-btn">Edit booking details</button>
                    </div>

                </div>
            </div>

        )
    },
    handleBackClick: function () {
        this.props.onChange({
            action: 'back'
        });
    },
    handleSubmitClick: function () {
        this.props.onChange({
            action: 'submit'
        });
    }
});

module.exports = Page2;


// WEBPACK FOOTER //
// ./app/components/Page2.js